/**
 * EDGECON: macht den Footer-Link „Cookie Einstellungen" funktionsfähig.
 *
 * Der Shop nutzt Shopifys nativen Einwilligungsbanner
 * (`/cdn/shopifycloud/privacy-banner/storefront-banner.js`). Der stellt zum erneuten Öffnen
 * der Auswahl `window.privacyBanner.showPreferences()` bereit — eine JS-Funktion, keine URL.
 * Ein Shopify-Menüpunkt kann aber nur auf eine Adresse zeigen. Diese Datei schlägt die
 * Brücke: sie fängt den Klick auf den Auslöser ab und ruft die Funktion auf.
 *
 * Ausgangslage (2026-08-30): der Menüpunkt zeigt auf `/pages/cookies`. Auf dieser Seite
 * steht als einziger Inhalt ein Button mit der ID `shopify-pc__banner__btn-manage-prefs`,
 * also der ID des echten Banner-Buttons — abgeschrieben, aber an keinen Handler gebunden.
 * Der Klick lief deshalb ins Leere. (Die doppelte ID sollte im Seiteninhalt ohnehin weg,
 * sobald der Banner sichtbar ist, existiert sie zweimal im Dokument.)
 *
 * Erkannt wird der Auslöser auf vier Wegen, damit die Datei auch nach einer Umstellung der
 * Navigation greift:
 *   1. ein Link auf `/pages/cookies` (der aktuelle Menüpunkt) — ein Klick, Dialog offen,
 *      die Zwischenseite wird gar nicht erst geladen
 *   2. jede Adresse, die auf `#cookie-einstellungen` endet  (der saubere Weg, wie bei EDGEFleet)
 *   3. ein Link mit der Adresse `#`, dessen Beschriftung genau „Cookie Einstellungen" lautet
 *   4. der Button im Inhalt der Seite `/pages/cookies` selbst — für alle, die direkt dort landen
 *
 * Ist der Banner nicht geladen — etwa weil die Region des Besuchers keine Einwilligung
 * verlangt —, wird der Klick nicht abgefangen. Der Link führt dann wie bisher auf die Seite,
 * es bricht nichts.
 */

const HASH = '#cookie-einstellungen';
const FALLBACK_LABEL = 'cookie einstellungen';
const PAGE_PATH = /\/pages\/cookies\/?$/;
const PREFS_BUTTON_ID = 'shopify-pc__banner__btn-manage-prefs';

function isTriggerLink(link) {
  const href = (link.getAttribute('href') || '').trim();
  if (!href) return false;

  if (href.toLowerCase().endsWith(HASH)) return true;
  if (href === '#' && link.textContent.trim().toLowerCase() === FALLBACK_LABEL) return true;

  // Die Adresse kann relativ, absolut oder mit Sprachpräfix kommen — über URL auflösen
  // statt am String zu raten, und nur den eigenen Shop abfangen.
  try {
    const url = new URL(href, window.location.href);
    return url.origin === window.location.origin && PAGE_PATH.test(url.pathname);
  } catch {
    return false;
  }
}

function isTriggerButton(button) {
  // Nur die Kopie im Seiteninhalt, nicht der Button des Banners selbst — der bringt
  // seinen eigenen Handler mit.
  return button.id === PREFS_BUTTON_ID && !button.closest('#shopify-pc__banner');
}

function isTrigger(element) {
  if (!element) return false;
  return element.tagName === 'A' ? isTriggerLink(element) : isTriggerButton(element);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a, button');
  if (!isTrigger(trigger)) return;

  const banner = window.privacyBanner;
  if (!banner || typeof banner.showPreferences !== 'function') return;

  event.preventDefault();
  banner.showPreferences();
});
